import Icon, { icons } from '../../generic/Icon';

import styles from './MarketingBlurb.module.less';

const Checkmark = () => (
  <span className={styles.checkmark}>
    <Icon icon={icons.check} />
  </span>
);

/** The marketing blurb (heading, paragraph, feature checklist) shown beside the sign-up card. */
const MarketingBlurb = () => (
  <section>
    <h1 className={styles.heading}>Start free and scale as you go</h1>
    <p className={styles.paragraph}>
      Continuous compliance checks and vulnerability management to keep your code risk-free.
    </p>
    <ul className={styles.featureList}>
      <li className={styles.item}><Checkmark /> License Identification</li>
      <li className={styles.item}><Checkmark /> Manage 5 Projects</li>
      <li className={styles.item}><Checkmark /> Vulnerability Management</li>
      <li className={styles.item}><Checkmark /> Basic Teams / Roles</li>
    </ul>
  </section>
);

export default MarketingBlurb;
